import styled from "@emotion/styled";
import { colors } from "@styles/design-tokens";

export const LogoContainer = styled.span`
    display: flex; /* Use flexbox for layout */
    align-items: center; /* Align items vertically centered */
    background-color: ${colors.middleBlueGreen};
    position: relative;
    z-index: 200;
    padding: 10px; /* Add padding for spacing */
`;

export const ImageStyled = styled.img`
    margin: 0 auto;
    display: block;
    width: 150px;
    border-radius: 40px;
    padding: 10px;

    ${(props) =>
        props.full
            ? `
        border-radius: 0;
        max-width: none;
        width: 100%;
        display: block;
      `
            : ""};
`;
export const LogoLink = styled.a`
    cursor: pointer;
    margin: 0 auto;
    display: block;
    width: 150px;
`;

export const VersionLink = styled.div`
    color: ${colors.white};
    font-size: 1rem;
    position: absolute;
    bottom: 30px;
    right: 10px;
    padding: 5px;

    @media (max-width: 768px) {
        position: absolute;
        font-size: 0.7rem;
        top: 70px;
        right: 10px;
    }
`;
